import React from 'react';
import Icon from './Icon';

const MapIcon = (props) => (
    <Icon {...props}>
        <path
            d="M9 18L3 21V6L9 3L15 6L21 3V18L15 21L9 18ZM9 3V18M15 6V21"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default MapIcon;
